import { defineStore } from "pinia";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { httpRequest } from "@follaw-fr/utils/request.utils";
import { handleNetworkError } from "@follaw-fr/utils/handleNetworkError";

const toast = useToast();

export const useRegisterStore = defineStore("registerStore", () => {
  const router = useRouter();

  const isLoading = ref(false);

  const occupations = ref([]);
  const sectors = ref([]);
  const user = ref(null);

  const getRegisterOptions = async () => {
    isLoading.value = true;

    try {
      const response = await httpRequest("get", "/users/registration-filters");
      if (response.data) {
        occupations.value = response.data.occupations;
        sectors.value = Object.entries(response.data.sectors_mapping).map(
          ([name, _id]) => ({ name, _id })
        );
      }
    } catch (err) {
      handleNetworkError(err);
    }
    isLoading.value = false;
  };

  const registerUser = async (payload) => {
    isLoading.value = true;

    if (!payload) {
      return;
    }

    try {
      const response = await httpRequest("post", "/users/register", payload);
      if (response.status === 201) {
        user.value = response.data;
        router.push({ name: "Connexion" });
      }

      toast.success(
        "Votre compte a été créé avec succès, merci de suivre les instructions reçues par email"
      );
    } catch (err) {
      handleNetworkError(err);
    }
    isLoading.value = false;
  };

  return {
    isLoading,
    occupations,
    sectors,
    user,
    getRegisterOptions,
    registerUser,
  };
});
